import { render, staticRenderFns } from "./Viaje.vue?vue&type=template&id=0b2ff14f&"
import script from "./Viaje.vue?vue&type=script&lang=js&"
export * from "./Viaje.vue?vue&type=script&lang=js&"
import style0 from "./Viaje.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports